import type { ReactNode } from 'react';
import { useT } from '../../i18n';
import styles from './Auth.module.css';

export function AuthLayout({ title, children }: { title?: string; children: ReactNode }) {
  const t = useT();
  return (
    <main className={styles.page}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        <div className={styles.dots} aria-hidden="true">
          {[0, 1, 2, 3].map((i) => (
            <span key={i} className={styles.dot} style={{ background: `var(--m${i})` }} />
          ))}
        </div>
        <h1 className={`display ${styles.brand}`}>{t.t('app.name')}</h1>
        <p className={styles.tagline}>{title ?? t.t('app.tagline')}</p>
      </div>
      {children}
    </main>
  );
}

export function Field({ label, hint, children }: { label: string; hint?: string; children: ReactNode }) {
  return (
    <label className={styles.field}>
      <span className={styles.fieldLabel}>{label}</span>
      {children}
      {hint ? <span className={styles.hint}>{hint}</span> : null}
    </label>
  );
}
